"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
function default_1(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { expect, conflictAction } = props;
    const action = conflictAction || expect
        ? () => {
            alert(t('로그인 후 이용 가능합니다.'));
            window.location.replace((0, string_utils_1.loginReturnPath)());
        }
        : () => {
            alert(t('이미 로그인 되어있습니다.'));
            (0, functions_1.replaceToMain)();
        };
    (0, react_1.useEffect)(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            yield (0, functions_1.getWhoAmI)().then(whoAmIData => {
                if (expect !== whoAmIData.is_logged_in)
                    action();
            });
        }))();
    }, []);
}
exports.default = default_1;
